"use strict";
exports.__esModule = true;
exports.DEFAULT_HEIGHT = exports.DEFAULT_WIDTH = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var utilities_1 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../utils");
exports.DEFAULT_WIDTH = 340;
exports.DEFAULT_HEIGHT = 500;
var Iframe = styled_components_1["default"].iframe(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin: auto;\n  display: flex;\n  border: none;\n  overflow: hidden;\n  max-width: 100%;\n"], ["\n  margin: auto;\n  display: flex;\n  border: none;\n  overflow: hidden;\n  max-width: 100%;\n"])));
var Facebookpage = function (_a) {
    var _b = _a.config, href = _b.data_href, tabs = _b.data_tabs, smallHeader = _b.data_small_header, showFacepile = _b.data_show_facepile, hideCover = _b.data_hide_cover, fbAppId = _b.fb_app_id, data_width = _b.data_width, data_height = _b.data_height;
    // 180 < width < 500
    var width = utils_1.getNumberValueInRange(data_width, exports.DEFAULT_WIDTH, 180, 500);
    // 70 < height
    var height = utils_1.getNumberValueInRange(data_height, exports.DEFAULT_HEIGHT, 70);
    var data = {};
    data.adapt_container_width = true;
    if (href) {
        data.href = href;
    }
    if (tabs) {
        data.tabs = tabs;
    }
    if (width) {
        data.width = width;
    }
    if (height) {
        data.height = height;
    }
    if (smallHeader) {
        data.small_header = smallHeader;
    }
    else {
        data.small_header = false;
    }
    if (showFacepile) {
        data.show_facepile = showFacepile;
    }
    else {
        data.show_facepile = false;
    }
    if (hideCover) {
        data.hide_cover = hideCover;
    }
    else {
        data.hide_cover = false;
    }
    if (fbAppId) {
        data.appId = fbAppId;
    }
    var src = "https://www.facebook.com/plugins/page.php?" + utilities_1.objectToParams(data);
    return (React.createElement(Iframe, { src: src, width: width, height: height, scrolling: "no", frameBorder: "0", allowTransparency: true, allow: "encrypted-media" }));
};
exports["default"] = Facebookpage;
var templateObject_1;
